// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  userId: __t.u64().name("user_id"),
  email: __t.string(),
  emailVerified: __t.bool().name("email_verified"),
  username: __t.string(),
  displayName: __t.option(__t.string()).name("display_name"),
  avatarUrl: __t.option(__t.string()).name("avatar_url"),
  statusMessage: __t.option(__t.string()).name("status_message"),
  online: __t.bool(),
  lastSeen: __t.timestamp().name("last_seen"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
